import { TRANSITION_CLASSNAME_MAP } from "./chunk-7HUMOKKM.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Transition/Transition.Child.tsx
import React from "react";
import { Transition as HeadlessUiTransition } from "@headlessui/react";
import clsx from "clsx";
var TransitionChild = _a => {
  var _b = _a,
    {
      variant,
      duration = "md",
      enter,
      enterFrom,
      enterTo,
      leave,
      leaveFrom,
      leaveTo
    } = _b,
    rest = __objRest(_b, ["variant", "duration", "enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo"]);
  if (!variant) {
    return /* @__PURE__ */React.createElement(HeadlessUiTransition.Child, __spreadProps(__spreadValues({}, rest), {
      enter,
      enterFrom,
      enterTo,
      leave,
      leaveFrom,
      leaveTo
    }));
  }
  return /* @__PURE__ */React.createElement(HeadlessUiTransition.Child, __spreadProps(__spreadValues({}, rest), {
    enter: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].enter, TRANSITION_CLASSNAME_MAP.duration[duration].enter, enter),
    enterFrom: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].enterFrom, enterFrom),
    enterTo: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].enterTo, enterTo),
    leave: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].leave, TRANSITION_CLASSNAME_MAP.duration[duration].leave, leave),
    leaveFrom: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].leaveFrom, leaveFrom),
    leaveTo: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].leaveTo, leaveTo)
  }));
};
var Transition_Child_default = TransitionChild;
export { Transition_Child_default };